import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TicketCreationService } from '../../../../../services';
import { ScoreQuestionType, TicketIssueType } from '@resident-nx/shared';
import { DatePipe, NgTemplateOutlet } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FileListPipe } from '../../../../../pipes/file-list.pipe';
import { TicketImageAttachmentComponent } from '../../../../molecules/ticket/ticket-image-attachment/ticket-image-attachment.component';
import { PdfAttachmentComponent } from '../../../../molecules/pdf-attachment/pdf-attachment.component';
import { DefaultValuePipe } from '@resident-nx/web/ui';
import { ImageBorderRadiusEnum } from '@resident-nx/web/util';

@Component({
  standalone: true,
  selector: 'rs-web-ticket-summary',
  templateUrl: './ticket-summary.component.html',
  styleUrl: './ticket-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgTemplateOutlet,
    FileListPipe,
    TranslateModule,
    DatePipe,
    TicketImageAttachmentComponent,
    PdfAttachmentComponent,
    DefaultValuePipe,
  ],
})
export class TicketSummaryComponent {
  protected readonly ScoreQuestionType = ScoreQuestionType;
  protected readonly ImageBorderRadiusEnum = ImageBorderRadiusEnum;
  protected readonly TicketIssueType = TicketIssueType;

  #ticketCreationService = inject(TicketCreationService);
  protected readonly ticketType = this.#ticketCreationService.type;
  public summary = this.#ticketCreationService.getSummaryData();
}
